import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null); // null=checking, false=anon

  const apply = (data) => {
    localStorage.setItem("c360_token", data.token);
    setSession(data);
  };

  useEffect(() => {
    if (!localStorage.getItem("c360_token")) { setSession(false); return; }
    api.get("/auth/me").then((r) => apply(r.data)).catch(() => setSession(false));
  }, []);

  const login = async (email, password) => apply((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => apply((await api.post("/auth/register", body)).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("c360_token");
    setSession(false);
  };
  const can = (perm) => !!session && session.permissions.includes(perm);

  return <AuthCtx.Provider value={{ session, login, register, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
